var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":_vm.width},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('v-img',{attrs:{"src":_vm.photo,"contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }